// extracted by mini-css-extract-plugin
export default {"container":"burger-ingredients_container__cxv5M","scrollbar":"burger-ingredients_scrollbar__y60d2","srollbar":"burger-ingredients_srollbar__TwlzG"};